import React from 'react';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Badge, Button, Card, Col, DatePicker, Divider, Popover, Row} from "antd";
import {NavLink} from "react-router-dom";
import Fuse from "fuse.js";
import PropTypes from 'prop-types';
import SearchBox from "../../Boilerplate/SearchBox";
import ExpandedList from "../../Boilerplate/ExpandedList";
import moment from "moment";
import {deleteDailyLog, getDailyLogs} from "../../../actions/dailyLog";
import UserSmall from "../../Boilerplate/UserSmall";
import {canCreateSub, canDelete} from "../../Boilerplate/permissions";
import {separatorJoin} from "../../Boilerplate/utilities";
import {compArr, subViewSelector} from "../selectors";
import {setViewPath} from "../../../actions/view";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {compose} from "redux";
import {DeleteButton} from "../DeleteButton";
import {numerAlnumComp} from "../../../common/sorters";

const filterState = {
  filterKeys: null,
  filterActive: false,
  dateRange: [],
};

class DailyLogList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...filterState};
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) { onMount(); }
  }

  setFilter = (phrase) => {
    if (phrase !== '') {
      let { dailyLogs } = this.props;
      dailyLogs = dailyLogs || [];
      const options = {
        keys: [
          'resource.summary',
        ],
        threshold: 0.3,
        id: 'resource.id'
      };
      let fuse = new Fuse(dailyLogs, options);
      this.setState({
        filterKeys: fuse.search(phrase),
        filterActive: true,
      });
    } else {
      this.setState({
        filterKeys: [],
        filterActive: false,
      });
    }
  };

  setDateRange = (range) => {
    this.setState({ dateRange: range });
  };

  clearDateRange = () => this.setDateRange(filterState.dateRange);

  checkFilters = () => {
    let { dateRange } = this.state;
    const [from, to] = dateRange;

    let newFilters = {};
    if (!compArr(dateRange, filterState.dateRange)) {
      if (from) newFilters.from = moment(from).startOf('day').format();
      if (to) newFilters.to = moment(to).endOf('day').format();
    }

    return newFilters;
  };

  render() {
    let { dailyLogs, project } = this.props;
    dailyLogs = dailyLogs || [];

    const { filterKeys, filterActive, dateRange } = this.state;
    const [from, to] = dateRange;
    const hasRange = from || to;
    if (dateRange[0]) {
      dailyLogs = dailyLogs.filter(log => moment(log.resource.logdate).isBetween(dateRange[0], dateRange[1], 'day', '[]'));
    }
    if (filterActive) {
      dailyLogs = dailyLogs.filter(item => filterKeys.includes(item.resource.id));
    }

    let index = dailyLogs.map(i=>i.resource);
    index.sort((a, b) => b.logdate.isSame(a.logdate) ? numerAlnumComp(a.number, b.number) : b.logdate.diff(a.logdate));
    index = index.map(i=>i.id);

    const isEmpty = obj => { for (let x in obj) { return false; } return true; };

    const renderFilterControls = () => <div className='bid-listing-control'>
      <DatePicker.RangePicker
        className='control-box'
        key='date-search'
        value={dateRange}
        onChange={range => this.setDateRange(range)}
        format='MM/DD/YYYY'
        style={{width: 400}}
      />
    </div>;


    return (
      <React.Fragment>
        <Row gutter={16}>
        <Card>
          <div className="bid-listing-header">
            <h1>Daily Logs</h1>
            <SearchBox
              className='control-box control-search'
              placeholder='search daily logs'
              onChange={value => this.setFilter(value)}
            />
          </div>
          <Divider/>
          <ExpandedList
            items={dailyLogs}
            index={index}
            derivedKey={item => item.resource.id}
            extra={(<React.Fragment>
              <Popover placement='bottom' content={renderFilterControls()} trigger='click'>
                <Button icon='filter' className={(!isEmpty(this.checkFilters())) && 'background-primary-1 color-grayscale-3'}>
                  <span className='hidden inline visible-lg'>Filter</span>
                </Button>
              </Popover>
              <Button type='primary' icon='plus' onClick={this.props.onNew} disabled={!canCreateSub('dailylog')(project)}>New Daily Log</Button>
            </React.Fragment>)}
            subExtra={<div>
              {hasRange && <Button className={'clear-filter'} size="small" onClick={this.clearDateRange}>Clear Calendar Filter</Button>}
            </div>}
            renderHeading={() => (
              <Row className='bid-listing-heading text-column'>
                <Col lg={18} md={17} sm={15} xs={13}>Log Entry</Col>
                <Col lg={6} md={7} sm={9} xs={11}>Issues & Delays</Col>
              </Row>
            )}
            renderTop={dailyLog => {
              let options = [];
              if (canDelete(dailyLog)) options.push(<DeleteButton fauxKey={'delete-' + dailyLog.resource.id} icon='delete'
                    title='Delete Daily Log' document={dailyLog} onDelete={this.props.onDelete} type='daily log'/>);
              return (
                <Row justify='space-between'>
                  <Col lg={18} md={17} sm={15} xs={13}>
                    <NavLink to={dailyLog.resource.id}>#{dailyLog.resource.number} - <DateDisplay
                      date={dailyLog.resource.logdate}/></NavLink>
                  </Col>
                  <Col lg={4} md={5} sm={7} xs={9}>
                    {dailyLog.resource.safetyissues ?
                      <Badge status='error' text='Safety Issues'/> :
                      <Badge status='success' text='No Safety Issues'/>}
                      <div className='collapse-issues'>
                        {dailyLog.resource.weatherdelays ?
                          <Badge status='error' text='Weather Delays'/> :
                          <Badge status='success' text='No Weather Delays'/>}<br/>
                        {dailyLog.resource.tradedelays ?
                          <Badge status='error' text='Trade Delays'/> :
                          <Badge status='success' text='No Trade Delays'/>}<br/>
                        {dailyLog.resource.safetydelays ?
                          <Badge status='error' text='Safety Delays'/> :
                          <Badge status='success' text='No Safety Delays'/>}<br/>
                        {dailyLog.resource.otherdelays ?
                          <Badge status='error' text='Other Delays'/> :
                          <Badge status='success' text='No Other Delays'/>}
                      </div>
                  </Col>
                  <Col span={2}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      {separatorJoin(options, <span> | </span>)}
                    </div>
                  </Col>
                </Row>
              );
            }}
            renderContent={dailyLog => (
              <Row gutter={24}>
                <Col lg={18} md={17} xs={24}>
                  {dailyLog.resource.summary}<br/>
                  <UserSmall id={dailyLog.resource.createdbyuserid}/>
                </Col>
                <Col lg={6} md={7} xs={0}>
                  {dailyLog.resource.safetyissues}
                  {dailyLog.resource.safetyissues && <React.Fragment><br/><br/></React.Fragment>}
                  {dailyLog.resource.weatherdelays ?
                    <React.Fragment><Badge className='offset-padding' status='error' text='Weather Delays'/><br/></React.Fragment> :
                    <Badge className='offset-padding' status='success' text='No Weather Delays'/>}
                  {dailyLog.resource.weatherdelays}
                  {dailyLog.resource.weatherdelays && <br/>}
                  <br/>
                  {dailyLog.resource.tradedelays ?
                    <React.Fragment><Badge className='offset-padding' status='error' text='Trade Delays'/><br/></React.Fragment> :
                    <Badge className='offset-padding' status='success' text='No Trade Delays'/>}
                  {dailyLog.resource.tradedelays}
                  {dailyLog.resource.tradedelays && <br/>}
                  <br/>
                  {dailyLog.resource.safetydelays ?
                    <React.Fragment><Badge className='offset-padding' status='error' text='Safety Delays'/><br/></React.Fragment> :
                    <Badge className='offset-padding' status='success' text='No Safety Delays'/>}
                  {dailyLog.resource.safetydelays}
                  {dailyLog.resource.safetydelays && <br/>}
                  <br/>
                  {dailyLog.resource.otherdelays ?
                    <React.Fragment><Badge className='offset-padding' status='error' text='Other Delays'/><br/></React.Fragment> :
                    <Badge className='offset-padding' status='success' text='No Other Delays'/>}
                  {dailyLog.resource.otherdelays}
                </Col>
              </Row>
            )}
          />
        </Card>
        </Row>
      </React.Fragment>
    );
  }
}

DailyLogList.propTypes = {
  dailyLogs: PropTypes.arrayOf(PropTypes.object),
};

export default compose(
  connect(
    (state, props) => {
      const project = state.view.data[props.match.params.id];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const listpath = ['projects', props.match.params.id, 'dailylogs'];
      if (!compArr(path, listpath) || loading) return { loading: true };
      const dailyLogs = subViewSelector(state, props);
      return { dailyLogs, project };
    },
    (dispatch, props) => ({
      loader: () => {
        dispatch(setViewPath(['projects', props.match.params.id, 'dailylogs']));
        dispatch(getDailyLogs(props.match.params.id));
      },
      onNew: () => props.history.push(`/projects/${props.match.params.id}/daily-logs/new`),
      onDelete: (dailyLogId) => dispatch(deleteDailyLog(props.match.params.id, dailyLogId)),
    })),
  withLoading
)(DailyLogList);



// WEBPACK FOOTER //
// ./src/components/Projects/DailyLogs/DailyLogList.js